export async function playAudio(audioSnippets, speechSynthesizerRate, smiMapService, onLoadedCallback) {

    if (!smiMapService) smiMapService = 'https://api.mapstrat.com';
    var rate = speechSynthesizerRate || 0;

    // Create audio element
    let soundEmbedContainer = document.getElementById('soundEmbedContainer');
    if (!soundEmbedContainer) {
        soundEmbedContainer = document.createElement('div');
        soundEmbedContainer.id = 'soundEmbedContainer';
        soundEmbedContainer.style.visibility = 'hidden';
        soundEmbedContainer.style.position = 'absolute';
        soundEmbedContainer.style.width = 0;
        soundEmbedContainer.style.height = 0;
        document.body.append(soundEmbedContainer);
    }

    soundEmbedContainer.innerHTML = ""; // Clear previous audio
    const audioPlayer = document.createElement("audio");
    soundEmbedContainer.append(audioPlayer);

    // Function: play ONE snippet and wait until it ends
    async function playOneSnippet(snippet) {
        return new Promise((resolve) => {

            let queryString =
                'rate=' + rate +
                '&ttsRequests[0][text]=' + encodeURIComponent(snippet.text) +
                '&ttsRequests[0][voice]=' + encodeURIComponent(snippet.voice);

            let url = smiMapService + '/api/TextToSpeech?' + queryString;

            audioPlayer.src = url;

            audioPlayer.onplaying = function () {
                if (typeof onLoadedCallback === 'function') onLoadedCallback();
            };

            audioPlayer.onended = function () {
                resolve(); // done playing this snippet
            };

            audioPlayer.play();
        });
    }

    // Play all snippets sequentially
    for (let snippet of audioSnippets) {
        await playOneSnippet(snippet);
    }

    return "done"; // Caller knows all audio completed
}
